<nz-card nzTitle="Condition Query">
  <nz-space nzDirection="vertical" nzSize="middle">
    <nz-divider [nzText]="searchTitle_start">
      <ng-template #searchTitle_start>
        <h4 class="search-title">Head Node</h4>
      </ng-template>
    </nz-divider>
    <br />

    <app-graph-search-item [searchType]="'startNode'"></app-graph-search-item>


    <nz-divider [nzText]="searchTitle_relation">
      <ng-template #searchTitle_relation>
        <h4 class="search-title">Relation</h4>
      </ng-template>
    </nz-divider>
    <br />

    <app-graph-search-item [searchType]="'relation'"></app-graph-search-item>


    <nz-divider [nzText]="searchTitle_end">
      <ng-template #searchTitle_end>
        <h4 class="search-title">Tail Node</h4>
      </ng-template>
    </nz-divider>
    <br />

    <app-graph-search-item [searchType]="'endNode'"></app-graph-search-item>

    <nz-divider></nz-divider>
    <button nz-button nzType="primary" nzBlock (click)="searchGraph()">Search</button>
  </nz-space>
</nz-card>
